var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { id: "dashboard" },
    },
    [
      _c(
        "el-container",
        { staticStyle: { "max-width": "600px" } },
        [
          _c("el-input", {
            attrs: { placeholder: "Search text" },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", type: "primary" },
              on: { click: _vm.loadData },
            },
            [_vm._v("Search")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-plus", type: "primary" },
              on: { click: _vm.handleEditUpdate },
            },
            [_vm._v("Add User")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            "default-sort": { prop: "id", order: "descending" },
            data: _vm.tableData,
            stripe: "",
          },
          on: { "sort-change": _vm.handleSortChange },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "70", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "E-mail", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var column = ref.column
                  var $index = ref.$index
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-edit", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEditUpdate(row)
                          },
                        },
                      },
                      [_vm._v("Edit")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-popconfirm",
                      {
                        attrs: { title: "Are you sure?" },
                        on: {
                          confirm: function ($event) {
                            return _vm.handleDelete(row)
                          },
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "reference",
                              icon: "el-icon-delete",
                              size: "small",
                            },
                            slot: "reference",
                          },
                          [_vm._v("Delete")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 20, 30, 40],
          layout: "sizes, prev, pager, next, total",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.modalTitle,
            visible: _vm.dialogVisible,
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.rowToShow
            ? [
                _c(
                  "el-form",
                  {
                    ref: "userForm",
                    attrs: {
                      model: _vm.rowToShow,
                      rules: _vm.rules,
                      "label-width": "170px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "First Name", prop: "first_name" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.rowToShow.first_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.rowToShow, "first_name", $$v)
                            },
                            expression: "rowToShow.first_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Last Name", prop: "last_name" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.rowToShow.last_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.rowToShow, "last_name", $$v)
                            },
                            expression: "rowToShow.last_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "E-mail", prop: "email" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.rowToShow.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.rowToShow, "email", $$v)
                            },
                            expression: "rowToShow.email",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "Password",
                          prop: "password",
                          rules: [
                            {
                              required: _vm.rowToShow.id ? false : true,
                              message: "Password is required",
                              trigger: "blur",
                            },
                            {
                              min: 8,
                              message:
                                "Password should be at least 8 characters",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "password" },
                          model: {
                            value: _vm.rowToShow.password,
                            callback: function ($$v) {
                              _vm.$set(_vm.rowToShow, "password", $$v)
                            },
                            expression: "rowToShow.password",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "Confirm Password",
                          prop: "password_confirmation",
                          rules: [
                            {
                              required:
                                _vm.rowToShow.id && !_vm.rowToShow.password
                                  ? false
                                  : true,
                              message: "Password Confirmation is required",
                              trigger: "blur",
                            },
                            {
                              validator: _vm.validatePassConfirmation,
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "password" },
                          model: {
                            value: _vm.rowToShow.password_confirmation,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rowToShow,
                                "password_confirmation",
                                $$v
                              )
                            },
                            expression: "rowToShow.password_confirmation",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading.fullscreen.lock",
                      value: _vm.fullScreenLoading,
                      expression: "fullScreenLoading",
                      modifiers: { fullscreen: true, lock: true },
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.saveUser },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }